import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "6ffc1839-5448-4065-bf91-cac7a9d71e33", content: "High total surface mass.", options: {} },
  { id: "306b6794-2821-4a8d-ac8f-04f68ceebc2f", content: "Multi-layered construction.", options: {} },
  { id: "ae6821f5-b718-48e9-a3c7-3b97efdb8dcb", content: "A layer of added mass.", options: {} },
  {
    id: "49b0ed68-61ba-451c-bf78-11a1e38c236e",
    content: "Large cavity in</br>lightweight constructions.",
    options: {},
  },
  {
    id: "f915582f-49a8-4bd2-962e-98e20f9afe12",
    content: "Empty cavity in</br>lightweight constructions.",
    options: {},
  },
  {
    id: "d1b08562-d65b-4da3-9a4d-5212a58a1130",
    content: "Single, massive but thin</br>load-bearing slab.",
    options: {},
  },
  {
    id: "3738b8f8-35b2-4776-baef-27a9cacb4993",
    content: "Thin floor layer and ceiling layer</br>in lightweight constructions.",
    options: {},
  },
];

export const task: Task = {
  id: "7e03358e-5247-4222-9ff9-c6de9bdcc2c4",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "6ffc1839-5448-4065-bf91-cac7a9d71e33",
    "306b6794-2821-4a8d-ac8f-04f68ceebc2f",
    "ae6821f5-b718-48e9-a3c7-3b97efdb8dcb",
    "49b0ed68-61ba-451c-bf78-11a1e38c236e",
  ],
};
